var map = {
	"./AiChef/router.tsx": 6685,
	"./AppSettings/router.tsx": 2180,
	"./Auth/router.tsx": 7407,
	"./Carts/router.tsx": 9249,
	"./Community/router.tsx": 6614,
	"./Favorites/router.tsx": 7634,
	"./Ingredients/router.tsx": 5080,
	"./Main/router.tsx": 9892,
	"./Menu/router.tsx": 1519,
	"./Recipes/router.tsx": 1983,
	"modules/AiChef/router.tsx": 6685,
	"modules/AppSettings/router.tsx": 2180,
	"modules/Auth/router.tsx": 7407,
	"modules/Carts/router.tsx": 9249,
	"modules/Community/router.tsx": 6614,
	"modules/Favorites/router.tsx": 7634,
	"modules/Ingredients/router.tsx": 5080,
	"modules/Main/router.tsx": 9892,
	"modules/Menu/router.tsx": 1519,
	"modules/Recipes/router.tsx": 1983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8847;